module.exports = __webpack_public_path__ + "static/media/success.b7a79d88.png";